import http from '../util/http';

import { ANY_ERROR } from './user_action_types';
import { history } from '../history/history';

export const postServerDataWithTypes= (url, data, type)=> async dispatch=> {
  const response= await http.post(url, data);
  if(response && response.data.statusCode== 200) {
    dispatch({
      type,
      payload: response.data.data
    });
  }
  else {
    dispatch({
      type: ANY_ERROR,
      payload: response? response.data.message: "NO RESPONSE"
    });
  }
}

export const getServerDataWithTypes= (url, type)=> async dispatch=> {
  const response= await http.get(url);
  console.log(url);
  
  if(response && response.data.statusCode== 200) {
    dispatch({
      type,
      payload: response.data.data
    });
  }
  else {
    dispatch({
      type: ANY_ERROR,
      payload: response? response.data.message: "NO RESPONSE"
    });
  }
}

export const postServerDataWithPath= (url, data, path)=> async dispatch=> {
  const response= await http.post(url, data);
  if(response && response.data.statusCode== 200) {
    let result= response.data.data;
    history.push(path, { result });
  }
  else {
    dispatch({
      type: ANY_ERROR,
      payload: response? response.data.message: "NO RESPONSE"
    });
  }
}

export const putServerDataWithPath = (url, data, path) => async dispatch=> {
  const response = await http.put(url, data);
  if(response && response.data.statusCode == 200) {
    
    let result = response.data.data;
    history.push(path, {result});
  } else {
    dispatch({
      type: ANY_ERROR,
      payload: response ? response.data.message: "NO RESPONSE"
    })
  }
}



// WEBPACK FOOTER //
// ./web/action/common_action.jsx